module.exports = __webpack_public_path__ + "static/media/smart-letter-logo-white.4f7ebc98.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/smart-letter-logo-white.png
// module id = 1321
// module chunks = 1